export const GET_COMMENTS_QUERY = `
  query GetComments($entityType: String!, $entityId: Int!) {
    comments(
      where: {
        entity_type: { _eq: $entityType }
        entity_id: { _eq: $entityId }
      }
      order_by: { created_at: asc }
    ) {
      id
      content
      entity_type
      entity_id
      user_id
      company_id
      created_at
      updated_at
      user {
        id
        first_name
        last_name
      }
    }
  }
`;
